import classNames from 'classnames'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React from 'react'
import {renderIf} from 'views/Shared'
import {renderIfElse} from "../../../Shared";
import useTranslate from "../../../../modules/local/useTranslate";
import {Avatar} from "antd";
import TooltipApp from "../../../../components/TooltipApp";
import {BsCaretDownFill, BsCaretRightFill} from "react-icons/bs";

const ListHeader = ({
                        title,
                        extra,
                        style,
                        className,
                        renderTitle,
                        description,
                    }) => (
    <Translate>
        {(t) => (
            <div className="flex flex-col flex-1 gap-1">
                <div
                    style={style}
                    className={classNames(
                        'flex items-center text-xl font-bold text-primary uppercase',
                        className
                    )}>
                    {_.isFunction(renderTitle)
                        ? renderTitle()
                        : renderIf(
                            title,
                            _.isString(title) ? <span>{t(title)}</span> : title
                        )}
                    {extra && <div className="flex flex-1 justify-end">{extra}</div>}
                </div>
                {renderIf(
                    description,
                    <div className="ml-2 text-sm text-color-500 italic">
                        {`* ${t(description)}`}
                    </div>
                )}
            </div>
        )}
    </Translate>
)

export const ListHeaderWithLine = ({
                                       title,
                                       extra,
                                       style,
                                       className,
                                       renderTitle,
                                       line = true
                                   }) => (
    <Translate>
        {(t) => (
            <div
                style={style}
                className={classNames('flex items-center gap-3', className)}>
                {_.isFunction(renderTitle)
                    ? renderTitle()
                    : renderIf(
                        title,
                        _.isString(title) ? (
                            <span className="font-medium text-color-300 uppercase italic">
                  {t(title)}
                </span>
                        ) : (
                            title
                        )
                    )}
                {renderIfElse(
                    line,
                    <div className="flex-1 border-b"/>,
                    <div className="flex-1"/>
                )}
                {extra}
            </div>
        )}
    </Translate>
)

export const ListHeaderLineAndDes = ({
                                         description,
                                         ...props
                                     }) => (
    <Translate>
        {(t) => (
            <div className="flex flex-col gap-1">
                <HeaderWithIconLine {...props}/>
                {renderIf(
                    description,
                    <div className="ml-1 md:ml-2 text-xs text-color-500 italic">
                        {`* ${t(description)}`}
                    </div>
                )}
            </div>
        )}
    </Translate>
)


export const HeaderWithIconLine = ({
                                       icon,
                                       title,
                                       subtitle,
                                       style,
                                       className,
                                       renderTitle,
                                       renderSubTitle,
                                       line = true,
                                       center = false,
                                       lineColor = 'border-color-50',
                                       extra,
                                   }) => (
    <Translate>
        {(t) => (
            <div className="flex flex-col space-y-1">
                <div style={style} className={classNames('flex items-center gap-2', className)}>
                    {icon}
                    {renderIf(
                        line && center,
                        <div className={classNames("flex-1 border-b", lineColor)}/>
                    )}
                    {_.isFunction(renderTitle)
                        ? renderTitle()
                        : renderIf(
                            title,
                            _.isString(title) ? (
                                <div className="flex items-center gap-2">
                                <span className="font-bold uppercase tracking-wider">
                                    {t(title)}
                                </span>
                                </div>
                            ) : title
                        )
                    }
                    {renderIf(
                        line,
                        <div className={classNames("flex-1 border-b", lineColor)}/>
                    )}
                    {extra}
                </div>
                {_.isFunction(renderSubTitle)
                    ? renderSubTitle()
                    : renderIf(
                        subtitle,
                        _.isString(subtitle) ? (
                            <div className="flex items-center gap-2">
                                <span className="">
                                    {t(subtitle)}
                                </span>
                            </div>
                        ) : subtitle
                    )
                }
            </div>
        )}
    </Translate>
)

export const ExtraExpandedButton = ({isToggle, toggle}) => {
    const t = useTranslate()
    return (
        <TooltipApp title={t('click to expand')} placement="bottomRight" classNames={{root: "text-xs italic"}}>
            <Avatar
                size={22}
                className="flex flex-center bg-blue-100 hover:bg-blue-200 rounded-xs cursor-pointer"
                icon={isToggle ? <BsCaretDownFill size={12} className="text-blue-600"/> :
                    <BsCaretRightFill size={12} className="text-blue-600"/>}
                onClick={toggle}
            />
        </TooltipApp>
    )
}

export default ListHeader
